// extracted by mini-css-extract-plugin
export default {"link":"SearchResult_link__koT5u","nonlink":"SearchResult_nonlink__yxmlu","pdcInstead":"SearchResult_pdcInstead__UxL4g"};